import { json_headers, request } from './common';

export interface RoomScore {
  roomName: string;
  score: number;
}

export interface RoomRankingResponse {
  rankingModel: string;
  confidenceThreshold: number;
  candidateName: string;
  ranking: Array<RoomScore>;
}

export default class HotelRoomMatchingService {
  static basePath() {
    return window.configs.API_HOST + '/api/hotel-room-matching/v1';
  }

  static rankRoomMatchCandidates(room: string, candidates: Array<string>): Promise<RoomRankingResponse> {
    return request(this.basePath() + '/rank', {
      method: 'PUT',
      headers: json_headers,
      body: JSON.stringify({
        supplier_name: room,
        candidate_names: candidates,
      }),
    }).then(
      (body) =>
        ({
          rankingModel: body.ranking_model,
          confidenceThreshold: body.confidence_threshold,
          candidateName: body.supplier_name,
          ranking: body.ranking.map(
            (roomScore) =>
              ({
                roomName: roomScore.room_name,
                score: roomScore.score,
              } as RoomScore),
          ),
        } as RoomRankingResponse),
    );
  }
}
